import n from "styled-components";
import { Button as t } from "./atoms-v2777.js";
const l = n.div`
  position: relative;
  z-index: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.zindex.tooltip")};
`, d = n.div`
  background-color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.backgroundInverse`)};
  border-radius: 2px;
  color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.inverse`)};
  -webkit-font-smoothing: antialiased;
  padding: 16px;
  position: relative;
`, a = n.button`
  ${t}

  display: inline-block;
`;
export {
  d as Content,
  a as DefaultTriggerElement,
  l as Tooltip
};
